import { useState } from 'react'
import { checkDocument, type AdminDocument } from '../lib/api'

/** Ein Dokument, das K4ia von einer Webseite liest — weder Datei noch getippt. */
export function istWebseite(doc: Pick<AdminDocument, 'r2Key' | 'body' | 'source'>): boolean {
  return doc.r2Key === null && doc.body === null && /^https?:\/\//i.test(doc.source)
}

function datum(iso: string): string {
  return new Date(iso).toLocaleString('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

/**
 * Prüfstand einer Webseite: wann K4ia zuletzt nachgesehen hat, wann sich
 * der Text zuletzt geändert hat, und ob der letzte Abruf scheiterte. Nachts
 * prüft der Worker von selbst (docs/OPERATIONS.md); „Jetzt prüfen" reiht
 * die Prüfung sofort ein.
 */
export function WebseitenStand({
  doc,
  onDone,
}: {
  doc: AdminDocument
  onDone: () => void | Promise<void>
}) {
  const [busy, setBusy] = useState(false)
  const [meldung, setMeldung] = useState<string | null>(null)
  if (!istWebseite(doc)) return null

  async function pruefen() {
    setBusy(true)
    setMeldung(null)
    try {
      await checkDocument(doc.id)
      setMeldung('Prüfung läuft — das Ergebnis steht gleich hier.')
      await onDone()
    } catch (err) {
      setMeldung(err instanceof Error ? err.message : String(err))
    } finally {
      setBusy(false)
    }
  }

  const pruefFehler = doc.status === 'indexed' && doc.errorMessage?.startsWith('Prüfung')
  return (
    <div className="mt-1 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-text-muted">
      <span>
        {doc.checkedAt ? `Geprüft ${datum(doc.checkedAt)}` : 'Noch nicht geprüft'}
        {doc.changedAt && <> · Inhalt geändert {datum(doc.changedAt)}</>}
        {' · wird täglich geprüft'}
      </span>
      {pruefFehler && <span className="text-status-pending">{doc.errorMessage}</span>}
      <button
        type="button"
        className="btn-chip"
        disabled={busy || doc.status === 'indexing'}
        onClick={() => void pruefen()}
      >
        {busy ? 'Reiht ein …' : 'Jetzt prüfen'}
      </button>
      {meldung && <span>{meldung}</span>}
    </div>
  )
}
